'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

WindowLocation.$inject = ['$window'];


var _module = _angular2.default.module('cb.util.WindowLocation', []);

_module.factory('WindowLocation', WindowLocation);

exports.default = _module;


function WindowLocation($window) {
    var service = {
        getHostname: getHostname,
        getSearch: getSearch
    };

    return service;

    /**
     * Get window.location because $location breaks anchor scroll.
     *
     * @returns {string}
     */
    function getHostname() {
        return $window.location.hostname;
    }

    function getSearch() {
        return $window.location.search;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/util/window-location.service.js
// module id = 833
// module chunks = 0